export default function mask() {
  $('[data-mask=phone]').mask('+7(999) 999-9999');
}
